export const getError = state => state.editProject.get('error')
export const getIsSubmitting = state => state.editProject.get('isSubmitting')
